import { useId } from 'react';

export default function ApplicationField({
  as = 'input',
  id,
  label,
  helperText,
  error,
  density = 'default',
  className = '',
  children,
  ...controlProps
}) {
  const generatedId = useId();
  const controlId = id || `av-app-field-${generatedId}`;
  const helperId = helperText ? `${controlId}-helper` : undefined;
  const errorId = error ? `${controlId}-error` : undefined;
  const describedBy = [errorId, helperId].filter(Boolean).join(' ') || undefined;

  if (!['input', 'select'].includes(as)) {
    throw new Error(`Unsupported ApplicationField control: ${as}`);
  }

  if (!['default', 'compact'].includes(density)) {
    throw new Error(`Unsupported ApplicationField density: ${density}`);
  }

  const Control = as;
  const fieldClasses = [
    'av-app-field',
    density === 'compact' ? 'av-app-field--compact' : '',
    className,
  ].filter(Boolean).join(' ');

  const props = {
    ...controlProps,
    'aria-describedby': describedBy,
    'aria-invalid': Boolean(error),
    className: 'av-app-field__control',
    id: controlId,
  };

  if (as === 'input' && !props.type) {
    props.type = 'text';
  }

  return (
    <div className={fieldClasses}>
      <label className="av-app-field__label" htmlFor={controlId}>
        {label}
      </label>

      <Control {...props}>
        {children}
      </Control>

      {error && (
        <p className="av-app-field__error" id={errorId}>
          {error}
        </p>
      )}

      {helperText && (
        <p className="av-app-field__helper" id={helperId}>
          {helperText}
        </p>
      )}
    </div>
  );
}
